
































import Vue, { VueConstructor } from "vue";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      inputElement: HTMLInputElement;
    };
  }
>).extend({
  name: "SendModal",
  props: {
    filled: {
      type: Boolean,
      default: false
    },
    sendError: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      name: ''
    };
  },
  mounted() {
    this.name = this.$store.getters.user;
  },
  methods: {
    send: function(): void {
      this.$emit("send", this.name);
    },
    close: function(): void {
      this.$emit("close");
    }
  }
});
